import { LocationLandingLayout, LocationPageContent } from './LocationLandingLayout'

const content: LocationPageContent = {
  locale: 'tr',
  slug: 'istanbul-bahcelievler-e-ticaret-danismanligi',
  meta: {
    title: 'İstanbul Bahçelievler E-Ticaret Danışmanlığı | Thinklyze',
    description:
      'Bahçelievler\'deki işletmeler için e-ticaret danışmanlığı. Trendyol, Hepsiburada, kendi siteniz ve pazaryerleri için satış artırma stratejileri.',
    keywords: [
      'Bahçelievler e-ticaret danışmanlığı',
      'İstanbul e-ticaret ajansı',
      'Bahçelievler online mağaza',
      'Trendyol danışmanlık istanbul',
      'Hepsiburada danışmanlık',
      'e-ticaret danışmanı istanbul',
      'pazaryeri yönetimi istanbul',
    ],
    canonical: 'https://thinklyze.com/istanbul-bahcelievler-e-ticaret-danismanligi',
  },
  hero: {
    badge: 'Bahçelievler E-Ticaret Danışmanlığı',
    title: 'Bahçelievler\'deki İşletmenizi Dijital Satış Makinesine Dönüştürün',
    subtitle:
      'Kendi e-ticaret sitenizden Trendyol ve Hepsiburada\'ya kadar tüm satış kanallarınızı optimize ediyoruz. Bahçelievler\'in rekabetçi perakende ortamında dijitalde öne çıkmanıza yardımcı oluyoruz.',
    stats: [
      { value: '%280', label: 'Ortalama Satış Artışı' },
      { value: '50+', label: 'E-Ticaret Projesi' },
      { value: '%45', label: 'Sepet Terk Oranı Düşüşü' },
    ],
    highlights: [
      {
        title: 'Çok Kanallı Satış Stratejisi',
        description:
          'Kendi mağazanız, Trendyol, Hepsiburada ve sosyal ticaret kanallarını entegre bir stratejiyle yönetiyoruz.',
      },
      {
        title: 'Ürün Listeleme Optimizasyonu',
        description:
          'Başlık, açıklama, görsel ve fiyat optimizasyonuyla listelemelerinizin görünürlüğünü ve dönüşüm oranını artırıyoruz.',
      },
      {
        title: 'Reklam & Organik Büyüme',
        description:
          'Pazaryeri reklamları ve SEO\'yu birlikte kullanarak en düşük müşteri edinme maliyetiyle satış büyümesi sağlıyoruz.',
      },
    ],
  },
  problemSolution: {
    title: 'E-Ticarette Büyümeyi Engelleyen Sorunlar',
    subtitle: 'Bahçelievler\'deki e-ticaret işletmelerinin en sık yaşadığı problemler.',
    items: [
      {
        title: 'Pazaryerinde düşük görünürlük',
        description:
          'Trendyol veya Hepsiburada\'da ürünleriniz listenin derinliklerinde kayboluyorsa rakipler sipariş alır, siz bakakalırsınız. Algoritma uyumlu listeleme optimizasyonuyla sizi üst sıralara taşıyoruz.',
      },
      {
        title: 'Yüksek iade ve şikayet oranı',
        description:
          'Yanıltıcı ürün açıklamaları ve yetersiz görseller iade maliyetini artırır. Doğru içerik yapısıyla iade oranını %30\'a kadar düşürüyoruz.',
      },
      {
        title: 'Düşük tekrar satın alma oranı',
        description:
          'Müşterinizi bir kez kazandıktan sonra bir daha göremiyorsanız kâr marjınız düşük kalır. E-posta otomasyonu ve retargeting ile tekrar satışı artırıyoruz.',
      },
      {
        title: 'Stok & fiyat yönetimi karmaşası',
        description:
          'Çok kanallı satışta stok senkronizasyonu ve dinamik fiyatlandırma kritik. Otomasyon çözümleriyle operasyon yükünü azaltıyoruz.',
      },
    ],
  },
  services: {
    title: 'E-Ticaret Danışmanlık Hizmetlerimiz',
    subtitle: 'Bahçelievler ve çevresindeki e-ticaret işletmelerine tam kapsamlı destek.',
    items: [
      {
        title: 'Pazaryeri Hesap Yönetimi',
        description:
          'Trendyol, Hepsiburada ve diğer platformlarda mağaza kurulumu, optimizasyon ve günlük yönetim hizmetleri.',
      },
      {
        title: 'E-Ticaret Web Sitesi & Mağaza Kurulumu',
        description:
          'Shopify veya WooCommerce ile hızlı, güvenli ve dönüşüm odaklı kendi e-ticaret mağazanızı kuruyoruz.',
      },
      {
        title: 'Ürün İçerik Optimizasyonu',
        description:
          'SEO uyumlu başlıklar, detaylı açıklamalar ve profesyonel görseller düzenleme hizmetiyle dönüşüm oranınızı artırın.',
      },
      {
        title: 'E-Ticaret Reklamcılığı',
        description:
          'Google Shopping, Meta Dynamic Ads ve pazaryeri sponsored reklamlarıyla satışları artırın, ROAS\'ı ölçün.',
      },
      {
        title: 'E-Posta & Otomasyon Pazarlama',
        description:
          'Sepet terk e-postaları, doğum günü kampanyaları ve VIP müşteri segmentasyonuyla tekrar satışları tetikleyin.',
      },
      {
        title: 'Analitik & Raporlama',
        description:
          'Hangi ürün, kanal ve kampanya kâr getiriyor? Veri panelleriyle karar vermeyi kolaylaştırıyoruz.',
      },
    ],
  },
  locationBenefits: {
    title: 'Bahçelievler\'de E-Ticaret Danışmanlığı Almanın Avantajları',
    items: [
      {
        title: 'Lokasyona Yakın, Anlık İletişim',
        description:
          'Bakırköy\'deki ofisimizden Bahçelievler işletmelerine anında destek. Yüz yüze toplantılar, saha ziyaretleri mümkün.',
      },
      {
        title: 'Avrupa Yakası Pazar Bilgisi',
        description:
          'Bölgedeki tüketici segmentlerini ve rekabeti yakından tanıyan ekibimiz size rekabet avantajı sağlar.',
      },
      {
        title: 'KOBİ\'ye Özel Çözümler',
        description:
          'Büyük kurumsal ajansların hantal süreçleri yok; Bahçelievler\'deki KOBİ\'lere uygun hızlı ve esnek hizmet.',
      },
      {
        title: 'Entegre Dijital Ekosistem',
        description:
          'Web sitesi, sosyal medya, reklamlar ve pazaryeri — tüm kanallar koordineli şekilde yönetilir, sinerji yaratır.',
      },
      {
        title: 'Başarıya Dayalı Büyüme Planı',
        description:
          'İlk 3 ayda ölçülebilir sonuçlar hedefliyoruz. Başarı metriklerimiz baştan netleştirilir.',
      },
      {
        title: 'Operasyonel Destek',
        description:
          'Sadece strateji değil; içerik üretimi, reklam yönetimi ve teknik sorunlar dahil uçtan uca destek.',
      },
    ],
  },
  industries: {
    title: 'Bahçelievler\'de E-Ticaret Danışmanlığı Verdiğimiz Sektörler',
    items: [
      { title: 'Tekstil & Giyim', description: 'Moda ve tekstil ürünleri için pazaryeri ve DTC satış optimizasyonu.' },
      { title: 'Ev & Yaşam', description: 'Mobilya, dekorasyon ve ev ürünleri kategorisinde görünürlük artırma.' },
      { title: 'Kişisel Bakım & Kozmetik', description: 'Beauty markaları için içerik, görsel ve UGC odaklı satış stratejisi.' },
      { title: 'Elektronik & Aksesuar', description: 'Yüksek rekabetin olduğu elektronik kategorisinde fiyat ve içerik optimizasyonu.' },
      { title: 'Gıda & İçecek', description: 'Online satış ve abonelik modeli için e-ticaret altyapısı ve pazarlama.' },
      { title: 'Spor & Outdoor', description: 'Spor ürünleri için mevsimsel kampanya yönetimi ve kanallar arası satış.' },
    ],
  },
  faqs: [
    {
      question: 'Trendyol veya Hepsiburada\'da satış yapıyorum, bana yardımcı olabilir misiniz?',
      answer:
        'Evet. Mevcut mağaza hesabınızı analiz ediyor, ürün içeriklerini optimize ediyor ve reklam yönetimini üstleniyoruz. İlk toplantıda mevcut durumunuzu değerlendiriyoruz.',
    },
    {
      question: 'Kendi e-ticaret sitemim yoksa nasıl başlamalıyım?',
      answer:
        'Shopify veya WooCommerce\'de hızla yayına girebilirsiniz. Kurulum, tema özelleştirme ve ödeme entegrasyonu dahil eksiksiz bir başlangıç paketi sunuyoruz.',
    },
    {
      question: 'E-ticaret danışmanlığı ne kadar sürer?',
      answer:
        'İlk optimizasyon sonuçları 4–8 haftada gözlemlenir. Sürdürülebilir büyüme için 3–6 aylık dönemler öneriyoruz.',
    },
    {
      question: 'Tek platform mı çok platform mu odaklı çalışıyorsunuz?',
      answer:
        'Her ikisini de yapıyoruz. Başlangıçta en karlı kanalınıza odaklanıp ardından diğer kanalları entegre eden çok platformlu bir büyüme planı öneriyoruz.',
    },
  ],
  cta: {
    badge: 'Bahçelievler E-Ticaret',
    title: 'Satışlarınızı Artırmaya Hazır Mısınız?',
    description:
      'Ücretsiz e-ticaret analizi için randevu alın. Mevcut satış kanallarınızı inceliyor, büyüme fırsatlarını ve öncelikli adımları belirliyoruz.',
  },
  areaServed: ['Bahçelievler', 'Bakırköy', 'Bağcılar', 'Güngören', 'Küçükçekmece', 'İstanbul'],
  coordinates: { latitude: 41.0016, longitude: 28.8776 },
  address: {
    streetAddress: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
    addressLocality: 'Bakırköy',
    addressRegion: 'İstanbul',
    postalCode: '34140',
    addressCountry: 'TR',
  },
  relatedServices: {
    title: 'İlgili Hizmetlerimiz',
    items: [
      { name: 'Pazaryeri Yönetimi', href: '/services/marketplace', description: 'Trendyol ve Hepsiburada\'da satışlarınızı büyütün.' },
      { name: 'Shopify Danışmanlığı', href: '/shopify', description: 'Shopify mağazanızı profesyonelce yönetin.' },
      { name: 'Google Ads', href: '/services/google-ads', description: 'Shopping kampanyalarıyla ürün satışlarını artırın.' },
      { name: 'Meta Ads', href: '/services/meta-ads', description: 'Dinamik ürün reklamlarıyla retargeting yapın.' },
    ],
  },
}

const IstanbulBahcelievlerETicaretDanismanligi = () => {
  return <LocationLandingLayout content={content} />
}

export default IstanbulBahcelievlerETicaretDanismanligi
